<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M7 18H17C18.6569 18 20 16.6569 20 15C20 13.5 18.9 12.25 17.4 12.04C17.13 9.64 15.09 7.75 12.6 7.75C10.58 7.75 8.82 8.97 8.05 10.7C5.72 10.95 4 12.88 4 15.25C4 16.77 5.23 18 6.75 18H7Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path d="M12 11V16M12 11L10 13M12 11L14 13" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" />
</svg>
